
import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { GridStatusChip } from 'styles/elements/styleElements'
import { Deals, DensityStyleTypes } from '../../../../types'

interface RenderStatusProps {
  params: { row: GridRenderCellParams<Deals, object> }
  orgId?: string
  densityStyles: DensityStyleTypes
  navigate?: (route: string) => void
}

const RenderStatusCell: React.FC<RenderStatusProps> = ({ params, densityStyles, navigate: _navigate }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      <GridStatusChip size="small" type={(params as any)?.value} label={(params as any)?.value} />
    </Box>
  )
}
export default RenderStatusCell
